"use strict";
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.subscriptionTermsSelector = void 0;

var subscriptionTermsSelector = function subscriptionTermsSelector(_ref) {
  var subscriptionTerms = _ref.subscriptionTerms;
  return subscriptionTerms;
};

exports.subscriptionTermsSelector = subscriptionTermsSelector;


//////////////////
// WEBPACK FOOTER
// ./js/selectors/SubscriptionTermSelectors.js
// module id = 355
// module chunks = 5 6 7